import React, { useState, useEffect, useRef } from 'react';
import { usePost, useFetchWithBody, usePostMutateWithSuccess } from '../../api/reactQueryCustomHooks';
import { apiRoute, ENUM_PAGEACTION_TYPE } from '../../constants/enum';
import { useSelector } from "react-redux";
import { ErrorCard, LoadingCard, MainContainer } from '../../components';
import dayjs from 'dayjs';
import { saveAs } from "file-saver";
import * as XLSX from 'xlsx';
import ExcelJS from "exceljs";
import { useModalToast } from "../../components/modalToast/ModalToastContext"
import { Button, Checkbox, Input, Spinner } from '@heroui/react';
import ConfirmBox from '../../components/ConfirmBox';
import { faCircleArrowUp, faDownload, faFileExcel, faSearchPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material';
import { validateDate } from '@mui/x-date-pickers';

const StockTally = () => {
  const [inputMode] = useState('manual');
  const [stockLocation, setStockLocation] = useState('');
  const [shape, setShape] = useState('');

  const [sizeFrom, setSizeFrom] = useState('');
  const [sizeTo, setSizeTo] = useState('');
  const [pageActionType, setPageActionType] = useState("")
  const [barcodeInput, setBarcodeInput] = useState('');
  const [currentStock, setCurrentStock] = useState([]);
  const [tallyStock, setTallyStock] = useState([]);
  const [allStockData, setAllStockData] = useState([]);
  const [showAlert, setShowAlert] = useState(false);
  const [isReportBarcode, setIsReportBarcode] = useState(false);
  const [isImportByReportNo, setIsImportByReportNo] = useState(false);
  const [itemToDelete, setItemToDelete] = useState("")
  const [searchText, setSearchText] = useState("")
  const [allSearchData, setAllSearchData] = useState([]);
  const { compCode, dbUser, compName } = useSelector((state) => state.company);
  const { user } = useSelector((state) => state.auth);
  const [stockIdSplitter, setStockIdSplitter] = useState("#")
  const [isExcelImport, setIsExcelImport] = useState(false)
  const [errorLog, setErrorLog] = useState({ invalid: [], tallied: [] })
  const [excelMapData, setExcelMapData] = useState([])
  const [excelRows, setExcelRows] = useState([])
  const fileInputRef = useRef(null)
  const [isExlProcess, setIsExlProcess] = useState(false)

  // Get location data
  const { show } = useModalToast();
  const { data: locationList = [] } = useFetchWithBody({
    url: apiRoute.stockEntry.getStockLocationList, // apiRoute.packetTransferEntry.getFromLocation,
    queryKey: ["locationList"],
    inputData: {
      compcode: compCode
    }
  });

  // Get shape data
  const { data: shapeList = [] } = useFetchWithBody({
    url: apiRoute.shape.getShape,
    queryKey: ["shapeList"],
    inputData: {
      compCode: compCode
    }
  });

  // API call for getting stock data
  const { isPending: isPendingStk, isError: isErrorStk, mutate: fetchStockData } = usePostMutateWithSuccess({
    queryKey: "stockData",
    url: apiRoute.stockTally.getStockTellyData,
  });

  const { mutate: fetchTallyStock, data: tallyData = [] } = usePost({
    queryKey: "stockData",
    url: apiRoute.stockTally.fetch,
    onSuccessTasks: (data) => {
      setTallyStock(data)
      setAllSearchData(data)

    }
  });
  useEffect(() => {
    fetchTallyStock({
      data: {}
    })
  }, [])

  const { isPending, isError, mutate: funAddUpdate } = usePostMutateWithSuccess({
    queryKey: "AddUpdateTallystockData",
    url: apiRoute.stockTally.add_update
  });

  const { isPending: isPendingDel, isError: isErrordel, mutate: fnDelete } = usePostMutateWithSuccess({
    queryKey: "Delete/ClearTallystockData",
    url: apiRoute.stockTally.deleteEntry
  });
  // Update current stock whenever allStockData or tallyStock changes
  const funSetCurrentStock = (allStock) => {

    if (allStock.length > 0) {
      const filteredCurrentStock = allStock.filter(item => {
        return !tallyStock.some(tallyItem =>
          //tallyItem.LotNo === item.LotNo && tallyItem.PktNo === item.PktNo
          tallyItem.LotNo?.trim().toLowerCase() === item?.LotNo?.trim().toLowerCase() &&
          tallyItem.PktNo?.trim().toLowerCase() === item?.PktNo?.trim().toLowerCase()
        );
      });

      //setCurrentStock(filteredCurrentStock.map(item => ({
      const stock = filteredCurrentStock.map(item => ({
        LotNo: item?.LotNo || '',
        PktNo: item?.PktNo || '',
        Shape: item?.ShapeName || '',
        Weight: item?.BWeight || '',
        ReportNo: item?.ReportNo || '',
      }));
      return stock
    }
    else
      return []

  }
  useEffect(() => {
    if (allStockData.length > 0 && !isExcelImport && (searchText == '' || searchText == null)) {
      const stock = funSetCurrentStock(allStockData)
      setCurrentStock(stock)
    }
  }, [allStockData, tallyStock, isExcelImport, searchText]);

  const handleAddBarcode = () => {
    if (showAlert || !barcodeInput.trim()) return;
    let item = {}
    // Split barcode into LotNo and PktNo (format: "PS#16")
    if (isReportBarcode) {
      item = currentStock.find(item =>
        item.ReportNo == barcodeInput)
    }
    else {
      const [lotNo, pktNo] = barcodeInput.split('#');
      if (!lotNo || !pktNo) {
        setShowAlert(true);
        show('Invalid barcode format. Please use format: LOT#PKT (e.g. PS#16)');
        setShowAlert(false);
        setBarcodeInput('');
        return;
      }
      item = currentStock.find(item =>
        //item.LotNo === lotNo && item.PktNo === pktNo
        item.LotNo?.trim().toLowerCase() === lotNo?.trim().toLowerCase() &&
        item.PktNo?.trim().toLowerCase() === pktNo?.trim().toLowerCase()
      );
    }

    // Find the item in current stock

    if (item) {
      setTallyStock([...tallyStock, item]);
      setAllSearchData([...tallyStock, item])
      setBarcodeInput('');

      funAddUpdate({
        data: {
          list_item: [{ "LotNo": item?.LotNo, "PktNo": item?.PktNo }],
          login_userid: user?.username
        },
        onSuccess: (data) => {

          if (inputRef.current) {
            inputRef.current.focus(); // safe to use the ref
          }
        }
      })

    } else {
      setShowAlert(true);
      const msg = isReportBarcode && barcodeInput.includes("#") ? "Invalid Report No. " : "Item not found in current stock"
      show(msg);
      setShowAlert(false);
      setBarcodeInput('');
    }
  };

  const handleConfirmBox = (data) => {
    if (data) {
      if (itemToDelete != "" && itemToDelete != null) {
        fnDelete({
          data: {
          },
          onSuccess: (data) => {

            setItemToDelete("")
            setPageActionType("")
            setTallyStock([])
            setAllSearchData([])
            fetchTallyStock({
              data: {}
            })
          }
        })
      }
    }
    else {
      setItemToDelete("")
      setPageActionType("")
    }

  }

  const handleClearTally = () => {
    setItemToDelete("ClearTally");
    setPageActionType(ENUM_PAGEACTION_TYPE.Delete)
  };

  const handleViewStock = () => {
    setIsExcelImport(false)
    if (!stockLocation) {
      show('Please select a stock location');
      return;
    }

    const fWeight = sizeFrom ? parseFloat(sizeFrom) : 0;
    const tWeight = sizeTo ? parseFloat(sizeTo) : 0;

    fetchStockData({
      data: {
        compcode: compCode,
        StkAt: stockLocation,
        tradeof: 'P',
        ShapeCode: shape,
        FWeight: fWeight,
        TWeight: tWeight
      }
    }, {
      onSuccess: (data) => {
        setAllStockData(data)


      },
      onError: (error) => {
        console.error("Error fetching stock data:", error);
      }
    });
  };
  const inputRef = useRef()
  // Calculate totals
  const currentStockTotalWeight = currentStock.reduce((sum, item) => sum + (item.Weight || 0), 0).toFixed(2);
  const tallyStockTotalWeight = tallyStock.reduce((sum, item) => sum + (item.Weight || 0), 0).toFixed(2);
  const searchInAllKeys = (data, searchText) => {
    if (!searchText) return data;

    const lowerSearch = searchText.toLowerCase();

    return data.filter(item =>
      Object.values(item).some(val =>
        val !== null &&
        val !== undefined &&
        val.toString().toLowerCase().includes(lowerSearch)
      )
    );
  };
  useEffect(() => {
    fetchTallyStock({
      data: {}
    })

  }, [])
  useEffect(() => {
    const searchData = searchInAllKeys(allSearchData, searchText)
    setTallyStock(searchData)
  }, [searchText])
  const resetValues = () => {
    setErrorLog({ invalid: [], tallied: [] })
    setExcelMapData([])
    setExcelRows([])
    if (fileInputRef.current) {
      fileInputRef.current.value = ''; // Clear file input
    }
  }
  useEffect(() => {
    if (!isExlProcess) {

      if (
        (errorLog && errorLog?.invalid?.length > 0) ||
        (errorLog && errorLog?.tallied?.length > 0)
      ) {
        downloadTextFile();   // auto download
      }
    }
  }, [isExlProcess, errorLog]);
  const handleCheckChange = (value) => {
    if (value == true && (stockLocation == "" || stockLocation == null)) {
      show("Select Stock Location")
      return;
    }
    setIsExcelImport(value)
    setBarcodeInput("")
    resetValues();
    //    setCurrentStock([])

  }
  const handleImportByReportNo = (value) => {
    setIsImportByReportNo(value)
    ValidateExcelRow(currentStock, excelRows, value, stockIdSplitter)


  }
  const handleStockSplitChange = (val) => {
    setStockIdSplitter(val)
    if (!isImportByReportNo) {
      ValidateExcelRow(currentStock, excelRows, isImportByReportNo, val)
    }


  }
  const ValidateExcelRow = (currentRow, excelRows, importByReport, stockIdSplit) => {
    const matchedItems = [];
    const invalidRows = [];
    const talliedRows = [];

    const stockMap = new Map(
      currentRow.map(item => [
        `${item?.LotNo?.trim()?.toLowerCase() || ""}|${item?.PktNo?.trim()?.toLowerCase() || ""}`,
        item
      ])
    );

    const talliedStockMap = new Map(
      tallyStock.map(item => [
        `${item?.LotNo?.trim()?.toLowerCase() || ""}|${item?.PktNo?.trim()?.toLowerCase() || ""}`,
        item
      ])
    );

    for (const row of excelRows) {
      try {
        const packet = [row[0]]
        if (!packet) {
          invalidRows.push(packet);
          // continue;
        }

        if (importByReport) {

          if (["#", "-"].some(char => String(packet).includes(char))) {
            invalidRows.push(packet);
            //continue;
          } else {
            const item = currentRow.find(
              s => String(s?.ReportNo ?? "") === String(packet)
            );

            if (item) {
              matchedItems.push(item);
            } else {
              const item = tallyStock.find(
                s => String(s?.ReportNo ?? "") === String(packet)
              );
              if (item)
                talliedRows.push(packet)
              else
                invalidRows.push(packet);
            }

            // continue;
          }
        }


        else {
          // Barcode mode
          if (["#", "-"].some(char => String(packet).includes(char))) {
            const [lotNo, pktNo] = String(packet)
              .trim()
              .split(stockIdSplit);


            if (!lotNo?.trim() || !pktNo?.trim()) {
              invalidRows.push(packet);
              //continue;
            }
            else {
              const key =
                `${lotNo.trim().toLowerCase()}|${pktNo.trim().toLowerCase()}`;

              const item = stockMap.get(key);

              // console.log("Lookup Key:", key);
              // console.log("Found Item:", item);

              if (item) {
                matchedItems.push(item);
              } else {
                const item = talliedStockMap.get(key)
                if (item)
                  talliedRows.push(packet)
                else
                  invalidRows.push(packet);
              }
            }
          }
          else {
            invalidRows.push(packet);
          }
        }
      } catch (err) {
        console.error("Error processing row:", row, err);
        invalidRows.push(row);
        setIsExlProcess(false)
      }
      finally {
        setIsExlProcess(false);
      }
    }

    // console.log("Matched Items:", matchedItems);
    // console.log("Invalid Rows:", invalidRows);

    //  Update state once
    setExcelMapData(prev => [...matchedItems]);

    //  if (invalidRows.length || talliedRows.length) {
    setErrorLog(prev => ({
      invalid: [...invalidRows],
      tallied: [...talliedRows]
    }));
    // }


  }
  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();

    reader.onload = (event) => {
      const binaryStr = event.target.result;
      const workbook = XLSX.read(binaryStr, { type: 'binary' });
      const worksheet = workbook.Sheets[workbook.SheetNames[0]];
      const rows = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

      if (!rows?.length) return;

      //const mapped = dataRows.filter((r) => r.length !== 0).map((row, ind) => {
      const dataRows = rows.slice(1).filter((r) => r.length !== 0);
      setExcelRows(dataRows)
      const headers = rows[0]; // Not used here but might be needed elsewhere
      if (dataRows && dataRows.length > 0) {
        fetchStockData({
          data: {
            compcode: compCode,
            StkAt: stockLocation,
            tradeof: "P",
            ShapeCode: '',
            FWeight: '0',
            TWeight: '0',
          },
          onSuccess: (data) => {
            setIsExlProcess(true)
            setAllStockData(data);
            const currentStock = funSetCurrentStock(data);
            setCurrentStock(currentStock)

            if (!currentStock?.length) {
              show("Current Stock Not Found");
              return;
            }

            ValidateExcelRow(currentStock, dataRows, isImportByReportNo, stockIdSplitter)

          },
        });
      }
      else {
        show("No data Found In Excel")
      }
    }
    reader.readAsBinaryString(file);

    // Reset file input so re-selecting same file triggers onChange
    e.target.value = null;
  };
  
  const handleDownloadExcel = () => {

    const headers = ["StockID / Report NO."]
    //if (headers && headers.length > 0) {
    //  Create a worksheet with headers only
    const ws = XLSX.utils.aoa_to_sheet([headers]);

    // Create a new workbook and append the worksheet
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

    // Generate Excel file buffer
    const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });

    // Trigger download with FileSaver
    const blob = new Blob([wbout], { type: "application/octet-stream" });
    saveAs(blob, "StockTallyUploadFormat.xlsx");


  }
  const handleTally = () => {

    if (excelMapData && excelMapData.length > 0) {
      funAddUpdate({
        data: {
          list_item: excelMapData,
          login_userid: user?.username
        },
        onSuccess: (data) => {
          fetchTallyStock({
            data: {}
          })
          resetValues();
          setIsExcelImport(false)
          setIsImportByReportNo(false)
          show("Tally Stock Upload Success")
        }
      })

    }
    else {
      show("No Data Found To Upload")
    }
  }

  const downloadTextFile = () => {
    let content = "Total No oF Packets Found in Excel:" + excelRows?.length + "\n\n";

    let uploadPkt = excelMapData.length


    content += "Total No Of Packets Ready for Stock Tally :" + uploadPkt + "\n\n";

    if (errorLog?.invalid?.length > 0) {
      content += "Total No Of Already Tallied Packets  :" + errorLog?.tallied?.length + "\n\n";
      errorLog?.tallied?.forEach((ele) => {
        content += `${ele}, `;
      });
      content += "\n\n";
    }


    if (errorLog?.invalid?.length > 0) {
      content += "Total No Of Invalid Packets / Invalid Format  :" + errorLog?.invalid?.length + "\n\n";
      errorLog?.invalid?.forEach((ele) => {
        content += `${ele}, `;
      });
      content += "\n\n";
    }





    const today = new Date();
    const formattedDate = today.toISOString().slice(0, 10); // "2025-01-15"

    const fileName = `StockTallyLogs-${formattedDate}.txt`

    const blob = new Blob([content], { type: "text/plain" });
    const url = URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;

    a.download = fileName
    a.click();

    URL.revokeObjectURL(url);
  };


  const exportToExcel = async (data) => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("TallyStock");

    // Company Name
    worksheet.mergeCells("A1:E1");
    const companyCell = worksheet.getCell("A1");
    companyCell.value = compName.join(",");
    companyCell.font = {
      bold: true,
      size: 18,
    };
    companyCell.alignment = {
      horizontal: "center",
      vertical: "middle",
    };

    // Report Name
    worksheet.mergeCells("A2:E2");
    const reportCell = worksheet.getCell("A2");
    reportCell.value = "Tally Stock Report";
    reportCell.font = {
      bold: true,
      size: 14,
    };
    reportCell.alignment = {
      horizontal: "center",
    };

    // Date
    worksheet.mergeCells("A3:E3");
    worksheet.getCell("A3").value = `Generated On : ${new Date().toLocaleString()}`;
    worksheet.getCell("A3").alignment = {
      horizontal: "right",
    };

    // Empty Row
    worksheet.addRow([]);

    // Header
    const headerRow = worksheet.addRow([
      "Lot No",
      "Pkt No",
      "Tally Date",
      "Weight",
      "Shape"

    ]);

    headerRow.eachCell((cell) => {
      cell.font = {
        bold: true,
        color: { argb: "FFFFFFFF" },
      };
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "1F4E78" },
      };
      cell.alignment = {
        horizontal: "center",
      };
      cell.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" },
      };
    });

    // Data
    tallyStock.forEach((item) => {
      const row = worksheet.addRow([
        item.LotNo,
        item.PktNo,
        new Date(item.Tally_Date), // Date object
        item.Weight,
        item.Shape

      ]);
      row.getCell(3).numFmt = "dd/mm/yyyy";
    });

    // Auto Width
    worksheet.columns.forEach((column) => {
      let maxLength = 10;
      column.eachCell({ includeEmpty: true }, (cell) => {
        const length = cell.value ? cell.value.toString().length : 10;
        if (length > maxLength) maxLength = length;
      });
      column.width = Math.min(maxLength + 2, 20); // Max width = 20
    });

    // Borders for data
    worksheet.eachRow((row, rowNumber) => {
      if (rowNumber >= 5) {
        row.eachCell((cell) => {
          cell.border = {
            top: { style: "thin" },
            left: { style: "thin" },
            bottom: { style: "thin" },
            right: { style: "thin" },
          };
        });
      }
    });

    const buffer = await workbook.xlsx.writeBuffer();

    saveAs(
      new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      }),
      "Tally_Stock.xlsx"
    );
  };
  if (isPendingDel) {
    return <LoadingCard />
  }
  if (isError || isErrordel || isErrorStk) {
    return <ErrorCard />
  }
  return (
    <>
      {itemToDelete && (
        <ConfirmBox
          handleConfirmBox={handleConfirmBox}
          actionType={pageActionType}
        />
      )}

      <MainContainer
        pageName={`Single Packet Stock Tally`}
        info={[]}
        breadcrumbs={[" Stock ", "Single Paycket Stock Tally"]}
      >

        <div className="min-h-screen bg-gray-50 ">
          <div className="max-w-7xl mx-auto">
            {/* Header */}
            {/* <div className="mb-">
            <h1 className="text-2xl font-bold text-gray-800 border-b-2 border-blue-500 pb-2">
              Single Packet Stock Tally
            </h1>
          </div> */}

            {/* Main Card Container */}
            <div className="bg-white rounded-lg shadow-md p-4 mb-6">
              {/* Filters Section */}
              <div className="bg-gray-50 rounded-lg p-4 mb-4">
                <h2 className="text-lg font-semibold text-gray-700 mb-3">Stock Filters</h2>
                <div className="grid grid-cols-1 md:grid-cols-5 gap-3">
                  <div>
                    <label htmlFor="location" className="block text-sm text-gray-700 mb-1">Stock Location *</label>
                    <select
                      id="location"
                      value={stockLocation}
                      onChange={(e) => setStockLocation(e.target.value)}
                      className="w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 p-2 border text-sm"
                      required
                    >
                      <option value="">Select Location</option>
                      {locationList?.map((loc) => (
                        <option key={loc.AC_ID} value={loc.AC_ID}>
                          {loc.AC_DESC}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div>
                    <label htmlFor="shape" className="block text-sm text-gray-700 mb-1">Shape</label>
                    <select
                      id="shape"
                      value={shape}
                      onChange={(e) => setShape(e.target.value)}
                      className="w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 p-2 border text-sm"
                    >
                      <option value="">All Shapes</option>
                      {shapeList?.map((shapeItem) => (
                        <option key={shapeItem.S_Code} value={shapeItem.S_Code}>
                          {shapeItem.S_Name}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div>
                    <label htmlFor="sizeFrom" className="block text-sm text-gray-700 mb-1">From Weight</label>
                    <input
                      type="number"
                      id="sizeFrom"
                      value={sizeFrom}
                      onChange={(e) => setSizeFrom(e.target.value)}
                      className="w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 p-2 border text-sm"
                      placeholder="From"
                      step="0.01"
                    />
                  </div>

                  <div>
                    <label htmlFor="sizeTo" className="block text-sm text-gray-700 mb-1">To Weight</label>
                    <input
                      type="number"
                      id="sizeTo"
                      value={sizeTo}
                      onChange={(e) => setSizeTo(e.target.value)}
                      className="w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 p-2 border text-sm"
                      placeholder="To"
                      step="0.01"
                    />
                  </div>

                  <div className="flex items-end">
                    <button
                      className="w-full bg-green-600 hover:bg-green-700 text-white py-2 px-2 rounded-md transition duration-200 text-sm"
                      onClick={handleViewStock}
                    >
                      View Stock
                    </button>
                  </div>
                </div>
              </div>

              {/* Barcode Entry Section */}
              <div className="bg-gray-50 rounded-lg p-4 mb-6">

                {!isExcelImport && <div className='flex gap-5 items-center p-2'>
                  <h2 className="text-lg font-semibold text-gray-700 ">Barcode Entry</h2>
                  <Checkbox size="md"
                    color="danger"
                    classNames={{ "label": "text-pink-700 text-xs font-semibold" }}
                    className="h-7  bg-white border-1 border-pink-200 "
                    isSelected={isReportBarcode} onValueChange={(e) => setIsReportBarcode(e)} >USE REPORT NO. BARCODE</Checkbox>
                </div>}
                <div className="flex gap-4 items-center mb-3">
                  {!isExcelImport && <input
                    type="text"
                    placeholder={`Enter barcode (e.g. ${isReportBarcode ? "7255793" : "PS#16"})`}
                    className="flex-1 rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 p-2 border text-sm"
                    value={barcodeInput}
                    ref={inputRef}
                    disabled={isExcelImport ? true : false}
                    onChange={(e) => setBarcodeInput(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        handleAddBarcode();
                      }
                    }}
                    onBlur={handleAddBarcode}
                    autoFocus
                  />}

                  <Checkbox size="sm"
                    classNames={{ "label": "text-white " }}
                    className="py-1 px-2 rounded-md bg-blue-800 border-blue-200 text-rose-700 border-0" label="gfu" color={"success"} isSelected={isExcelImport}
                    onValueChange={(e) => handleCheckChange(e)}>
                    <FontAwesomeIcon className="mr-2" icon={faFileExcel} ></FontAwesomeIcon>
                    Import From Excel</Checkbox>
                  {isExcelImport ? <> <Checkbox size="sm"
                    classNames={{ "label": "text-rose-700 " }}
                    className=" py-1 px-2 ml-2 mr-1 rounded-md bg-rose-100 border-blue-200 text-rose-700 border-0" label="gfu"
                    color={"danger"} isSelected={isImportByReportNo}
                    onValueChange={handleImportByReportNo}>
                    <FontAwesomeIcon className="mr-2" icon={faCircleArrowUp} ></FontAwesomeIcon>
                    Import By Report No.</Checkbox>
                    {!isImportByReportNo ?
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Typography
                          sx={{
                            fontSize: "0.8rem",
                            fontWeight: 600,
                            color: "#be079c"
                          }}
                        >
                          StockId Splitter:
                        </Typography>

                        <ToggleButtonGroup
                          value={stockIdSplitter}
                          exclusive
                          onChange={(e, val) => handleStockSplitChange(val)}
                          size="small"
                          color="secondary"
                          sx={{
                            height: 25,

                            '& .MuiToggleButton-root': {
                              px: 1.5,
                              py: 0.1,
                              fontSize: "1.1rem",
                              fontWeight: 600,
                              textTransform: "none",
                              border: '1px solid #be079c',
                              borderRadius: 0
                            },

                            // vertical divider
                            '& .MuiToggleButton-root:not(:last-of-type)': {
                              borderRight: '1px solid #be079c'
                            },

                            '& .Mui-selected': {
                              backgroundColor: '#800471 !important',
                              color: '#ffffff !important',

                              '&:hover': {
                                backgroundColor: '#840675b1'
                              }
                            }
                          }}
                        >
                          <ToggleButton value="#">#</ToggleButton>
                          <ToggleButton value="-">-</ToggleButton>
                        </ToggleButtonGroup>
                      </Box> : ""}
                    <Button size="sm" auto color="warning"
                      onPress={handleDownloadExcel}
                      className="ml-4 h-6"
                      startContent={<FontAwesomeIcon icon={faDownload} />} >
                      Import Excel Format
                    </Button>
                  </> : ""}
                </div>
                {isExcelImport ?
                  <div>
                    {/* {isLoadingDupPktList || isPendingStkPos ? <div className=" flex gap-1 p-2 justify-center font-semibold border-0 b-red-500 text-pink-700 text-center ">
                                                                      <h2 className=" px-2" >Proccessing....</h2>
                                                                      <Spinner size="sm" label="" className="" variant="simple" color="danger" labelColor="danger" />
                                                                  </div> : ""} */}
                    <Input type="file" color="success" size="md" variant="flat"
                      ref={fileInputRef}
                      // className="w-1/2"
                      classNames={{ label: "text-lg text-slate-700 font-semibold" }}
                      // isRequired={isExcelImport}
                      label="Import From Excel" accept=".xlsx, .xls" onChange={handleFileUpload} ></Input>
                  </div> : ""}
              </div>
              {isExlProcess || isPendingStk && (
                <div className=" flex gap-1 p-2 justify-center font-semibold border-0 b-red-500 text-pink-700 text-center ">
                  <h2 className=" px-2" >Proccessing....</h2>
                  <Spinner size="sm" label="" className="" variant="simple" color="danger" labelColor="danger" />
                </div>
              )}
              {isPending ? <div className=" flex gap-1 p-2 justify-center font-semibold border-0 b-red-500 text-pink-700 text-center ">
                <h2 className=" px-2" >Proccessing....</h2>
                <Spinner size="sm" label="" className="" variant="simple" color="danger" labelColor="danger" />
              </div> : ""}

              <div className='flex gap-5 items-center'>
                {isExcelImport && excelRows?.length > 0 && <div className='mt-3 font-semibold text-sm w-full  p-2 bg-gray-50 flex items-center gap-5' > <div className=''><h2 className="text-red-600 ">
                  Packets Ready for Stock Tally : {excelMapData.length} </h2>
                  <h2>Total Packets Found in Excel :{excelRows?.length}</h2>
                </div>
                  {excelMapData && excelMapData.length > 0 && <button
                    onClick={handleTally}
                    className="px-3 py-1 text-xs bg-green-600 text-white rounded hover:bg-green-700"
                  >
                    Upload Tally Stock
                  </button>}</div>}
              </div>
              {errorLog && errorLog?.tallied?.length > 0 ? (
                <div className=" bg-lime-50 p-2 text-sm my-2">
                  <h2 className="p-2  text-sm  font-semibold text-blue-700">  {isImportByReportNo ? "Report No." : "Packets"}
                    Already Exists In Tally Stock : ( {errorLog?.tallied?.length} )</h2>
                  <div className="flex gap-2 flex-wrap">
                    {errorLog?.tallied?.map((ele, i) => (
                      <div key={i}>
                        {ele} ,
                      </div>
                    ))}
                  </div>
                </div>
              ) : null}
              {errorLog && errorLog?.invalid?.length > 0 ? (
                <div className=" bg-rose-50 p-2 text-sm my-2">
                  <h2 className="p-2  text-sm  font-semibold text-blue-700">  {isImportByReportNo ? "Report No." : "Packets"}
                    Not Found In Current Stock  / Invalid {isImportByReportNo ? "Report No." : "StockId"} Format:  ( {errorLog?.invalid?.length} )</h2>
                  <div className="flex gap-2 flex-wrap">
                    {errorLog?.invalid?.map((ele, i) => (
                      <div key={i}>
                        {ele} ,
                      </div>
                    ))}
                  </div>
                </div>
              ) : null}
              {/* Stock Tables */}
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                {/* Current Stock */}
                <div className="bg-gray-50 rounded-lg shadow-sm overflow-hidden border border-gray-200">
                  <div className="px-4 py-3 border-b border-gray-200 bg-gray-100">
                    <h3 className="text-lg font-medium text-gray-900">Current Stock</h3>
                    <p className="text-sm text-gray-500">{currentStock.length} items available</p>
                  </div>
                  <div className="overflow-x-auto" style={{ maxHeight: '400px' }}>
                    <table className="min-w-full divide-y divide-gray-200">
                      <thead className="bg-gray-100">
                        <tr>
                          <th scope="col" className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase whitespace-nowrap tracking-wider">Lot No</th>
                          <th scope="col" className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase whitespace-nowrap tracking-wider">Pkt No</th>
                          <th scope="col" className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">ReportNo.</th>
                          <th scope="col" className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Weight</th>
                          <th scope="col" className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Shape</th>
                        </tr>
                      </thead>
                      <tbody className="bg-white divide-y divide-gray-200">
                        {currentStock.map((item, index) => (
                          <tr key={`${item.LotNo}-${item.PktNo}-${index}`} className="hover:bg-gray-50">
                            <td className="px-4 py-2 whitespace-nowrap text-sm font-medium text-gray-700">{item.LotNo}</td>
                            <td className="px-4 py-2 whitespace-nowrap text-sm text-gray-700">{item.PktNo}</td>
                            <td className="px-4 py-2 whitespace-nowrap text-sm text-gray-700">{item.ReportNo}</td>
                            <td className="px-4 py-2 whitespace-nowrap text-sm text-gray-700">{item.Weight}</td>
                            <td className="px-4 py-2 whitespace-nowrap text-sm text-gray-700">{item.Shape}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  <div className="bg-gray-100 px-4 py-2 border-t border-gray-200 flex justify-between text-sm">
                    <div>
                      <span className="font-medium text-gray-700">Total Packets:</span> <span className="font-bold">{currentStock.length} </span>
                    </div>
                    <div>
                      <span className="font-medium text-gray-700">Total Weight:</span> <span className="font-bold"> {currentStockTotalWeight} CT </span>
                    </div>
                  </div>
                </div>

                {/* Tally Stock */}
                <div className="bg-blue-50 rounded-lg shadow-sm overflow-hidden border border-blue-100">
                  <div className="px-4 py-3 border-b border-blue-200 bg-blue-100">
                    <div className="flex justify-between items-center">
                      <div>
                        <h3 className="text-lg font-medium text-blue-900">Tally Stock</h3>
                        <div className='flex  flex-wrap sm:flex-nowrap md:flex-nowrap gap-2 items-center'>
                          <p className="text-sm text-blue-700 whitespace-nowrap">{tallyStock.length} items tallied</p>
                          <Input type="text" size="sm"
                            radius="none" placeholder="Search ...."
                            startContent={<FontAwesomeIcon className="text-gray-700" icon={faSearchPlus}></FontAwesomeIcon>}
                            variant="bordered" className="bg-white border-0  border-gray-300"
                            value={searchText} onChange={(e) => setSearchText(e.target.value)}  ></Input>
                        </div>
                      </div>
                      <div>
                        <button
                          onClick={handleClearTally}
                          className="text-white hover:text-white bg-red-500 whitespace-nowrap  hover:bg-red-600 px-3 py-1 rounded text-sm font-medium transition-colors"
                        >
                          Clear All Tally
                        </button>
                        <br />
                        {tallyStock && tallyStock.length>0 &&
                        <button
                          onClick={exportToExcel}
                          className="text-white mt-2 hover:text-white bg-green-500 whitespace-nowrap  hover:bg-green-600 px-3 py-1 rounded text-sm font-medium transition-colors"
                        >
                          Export All Tally
                        </button>}
                      </div>

                    </div>
                  </div>
                  <div className="overflow-x-auto" style={{ maxHeight: '400px' }}>
                    <table className="min-w-full divide-y divide-blue-200">
                      <thead className="bg-blue-100">
                        <tr>
                          <th scope="col" className="px-4 py-2 text-left text-xs font-medium text-blue-800 uppercase tracking-wider">Lot No</th>
                          <th scope="col" className="px-4 py-2 text-left text-xs font-medium text-blue-800 uppercase tracking-wider">Pkt No</th>

                          <th scope="col" className="px-4 py-2 text-left text-xs font-medium text-blue-800 uppercase tracking-wider">Report No</th>
                          <th scope="col" className="px-4 py-2 text-left text-xs font-medium text-blue-800 uppercase tracking-wider">Weight (kg)</th>
                          <th scope="col" className="px-4 py-2 text-left text-xs font-medium text-blue-800 uppercase tracking-wider">Shape</th>
                        </tr>
                      </thead>
                      <tbody className="bg-blue-50 divide-y divide-blue-200">
                        {tallyStock.map((item, index) => (
                          <tr key={`${item.LotNo}-${item.PktNo}-${index}`} className="hover:bg-blue-100">
                            <td className="px-4 py-2 whitespace-nowrap text-sm font-medium text-blue-900">{item.LotNo}</td>
                            <td className="px-4 py-2 whitespace-nowrap text-sm text-blue-900">{item.PktNo}</td>
                            <td className="px-4 py-2 whitespace-nowrap text-sm text-blue-900">{item.ReportNo}</td>
                            <td className="px-4 py-2 whitespace-nowrap text-sm text-blue-900">{item.Weight}</td>
                            <td className="px-4 py-2 whitespace-nowrap text-sm text-blue-900">{item.Shape}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  <div className="bg-blue-100 px-4 py-2 border-t border-blue-200 flex justify-between">
                    <div className="flex justify-between w-full">
                      <div className="text-sm">
                        <span className="font-medium text-blue-800">Total Packets:</span> <span className='font-bold text-blue-900'>{tallyStock.length}</span>
                      </div>
                      <div className="text-sm">
                        <span className="font-medium text-blue-800">Total Weight:</span> <span className='font-bold text-blue-900'>{tallyStockTotalWeight} CT</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </MainContainer>
    </>
  );
};

export default StockTally;